import React, { useEffect, useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { AXIOS } from './utils/axios'
import styled from '@emotion/styled/macro'

import { Loader, AlbumList, MusicPlayer, Footer } from './components'

import './global/index.css'
import { useGlobalContext } from './context'
import { ScrollDown } from './assets/icons'

export default function App() {
  const [data, setData] = useState([])
  const { activeGenre, setActiveGenre, setHasChange } = useGlobalContext()
  const [isLoading, setIsLoading] = useState(true)

  const getAllGenre = () => {
    try {
      AXIOS.get('/genre/all')
        .then((response) => {
          if (response.status === 200) {
            const newActiveGenre = response.data.data?.find((item) => item.genre === activeGenre.genre)

            if (newActiveGenre?.title !== activeGenre?.title) {
              setActiveGenre(newActiveGenre)
              setHasChange(true)
            } else {
              setHasChange(false)
            }
            setData(response.data.data)
            setIsLoading(false)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    } catch (error) {
      console.log('we have error')
    }
  }

  //every 5 seconds call api
  //^ i hate this sections!

  useEffect(() => {
    getAllGenre()
    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    let interval
    interval = setInterval(() => {
      if (!document.hidden) getAllGenre()
    }, 5000)

    return () => {
      clearInterval(interval)
    }
    //eslint-disable-next-line
  }, [activeGenre])

  if (data.length === 0 && !isLoading) {
    return (
      <ErrorWrapper>
        <h2>الان چیزی برای پخش نداریم، بعداً دوباره سر بزن</h2>
      </ErrorWrapper>
    )
  }

  return (
    <ErrorBoundary
      fallback={
        <ErrorWrapper>
          <h2>یه مشکلی پیش اومد، صفحه رو رفرش کن</h2>
        </ErrorWrapper>
      }
    >
      <PageWrapper>
        <Wrapper>
          <div className='visually-hidden'>
            <h1>رادیو آنلاین ناین کرفت</h1>
            <p>
              در رادیو ناین کرفت، آهنگ‌های منتخب را به‌صورت زنده و آنلاین گوش دهید.
              از پاپ، رپ و راک تا لوفای، فانک، بلوز، کانتری و موسیقی متن (OST).
            </p>
            <h2>پخش زنده آهنگ در ژانرهای مختلف</h2>
            <p>
              پلی‌لیست رادیو ناین کرفت شامل آهنگ‌هایی در ژانرهای پاپ، رپ، راک، لوفای،
              فانک، بلوز، کانتری و موسیقی متن (OST) است.
            </p>
            <h2>ژانرهای رادیو ناین کرفت</h2>
          </div>
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <MusicPlayer />
              <AlbumList array={data} />
            </>
          )}
          {!isLoading && <ScrollDown />}
        </Wrapper>
        <Footer />
      </PageWrapper>
    </ErrorBoundary>
  )
}

const PageWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100dvh',
}))

const Wrapper = styled('main')(() => ({
  display: 'flex',
  gap: '2rem',
  margin: 'auto',
  placeItems: 'center',
  maxWidth: '1400px',
  flex: '1',
  position: 'relative',
  '.scroll': {
    position: 'absolute',
    bottom: '47%',
    right: '-5%',
    fill: 'var(--text-white)',
    width: '50px',
    animation: 'bounce 3s ease infinite',
  },
  '@media (width < 1550px)': {
    '.scroll': {
      right: '-2%',
    },
  },
  '@media (width < 1450px)': {
    '.scroll': {
      bottom: '0%',
      right: '35%',
    },
  },
  '@media (width < 1350px)': {
    flexDirection: 'column',
    '.scroll': {
      display: 'none',
    },
  },
  '@keyframes bounce': {
    '0% , 20% , 50% , 80% , 100%': { transform: 'translateY(0)' },
    '40%': { transform: 'translateY(-20px)' },
    '60%': { transform: 'translateY(-10px)' },
  },
}))

const ErrorWrapper = styled('main')(() => ({
  display: 'flex',
  margin: 'auto',
  placeItems: 'center',
  height: '100dvh',
  width: '100vw',
  h2: {
    padding: '1.5rem',
    width: '100%',
    textAlign: 'center',
    color: 'var(--text-white)',
  },
}))
